
const fakeBackend = () => {

};

export default fakeBackend;
